import axios from 'axios'
import { extractError } from '../utils/errorHandler'
import { API_SERVER_RETENTION } from '../../config/app.config'

export const getWeekIndicators = async () => {
  try {
    const { data: indicators } = await axios.get('home', {
      baseURL: API_SERVER_RETENTION,
    })
    // const { lastProducedOrders, weekIndicators } = indicators
    return indicators
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const getOnboarding = async () => {
  try {
    const { data: indicators } = await axios.get('home/onboarding', {
      baseURL: API_SERVER_RETENTION,
    })
    // const { lastProducedOrders, weekIndicators } = indicators
    return indicators
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const getLastUpdates = async () => {
  try {
    const { data: indicators } = await axios.get('home/news/list', {
      baseURL: API_SERVER_RETENTION,
    })
    // const { lastProducedOrders, weekIndicators } = indicators
    return indicators
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const getHomeKpis = async () => {
  try {
    const { data: kpis } = await axios.get('home/kpis', {
      baseURL: API_SERVER_RETENTION,
    })
    return kpis
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

/** Ordens atrasadas (fim planejado vencido e não executadas), as mais atrasadas primeiro. */
export const getDelayedOrders = async (offset = 0, limit = 20) => {
  try {
    const { data } = await axios.get('home/delayed', {
      baseURL: API_SERVER_RETENTION,
      params: { offset, limit },
    })
    return data
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}
